// Typing Indicator Component
// Following existing patterns from ActivityFeed

import React from 'react';
import { TypingIndicatorProps } from '../../../types/messaging';
import {
  TypingIndicator as StyledTypingIndicator,
  TypingDots
} from '../../../styles/Messaging';

export const TypingIndicator: React.FC<TypingIndicatorProps> = ({
  users
}) => {
  if (!users || users.length === 0) return null;

  const getTypingText = () => {
    if (users.length === 1) {
      return `${users[0].userName} is typing`;
    } else if (users.length === 2) {
      return `${users[0].userName} and ${users[1].userName} are typing`;
    } else {
      return `${users.length} people are typing`;
    }
  };

  return (
    <StyledTypingIndicator>
      {getTypingText()}
      <TypingDots>
        <span></span>
        <span></span>
        <span></span>
      </TypingDots>
    </StyledTypingIndicator>
  );
};
